import {
  LIST_JOB_TITLE_REQUEST,
  LIST_JOB_TITLE_SUCCESS,
  LIST_JOB_TITLE_FAIL,
  LIST_JOB_TITLE_SUMMARY_REQUEST,
  LIST_JOB_TITLE_SUMMARY_SUCCESS,
  LIST_JOB_TITLE_SUMMARY_FAIL,
  CREATE_JOB_TITLE_REQUEST,
  CREATE_JOB_TITLE_SUCCESS,
  CREATE_JOB_TITLE_FAIL,
  DETAIL_JOB_TITLE_REQUEST,
  DETAIL_JOB_TITLE_SUCCESS,
  DETAIL_JOB_TITLE_FAIL,
  UPDATE_JOB_TITLE_REQUEST,
  UPDATE_JOB_TITLE_SUCCESS,
  UPDATE_JOB_TITLE_FAIL,
  DELETE_JOB_TITLE_REQUEST,
  DELETE_JOB_TITLE_SUCCESS,
  DELETE_JOB_TITLE_FAIL
} from '../../constants/job-titles'

const initialState = {
  loading: false,
  jobTitles: [],
  jobTitle: {},
  jobTitlesSummary: [],
  pageable: {},
  error: null
}

const jobTitleReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_JOB_TITLE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_JOB_TITLE_SUCCESS:
      return {
        ...state,
        loading: false,
        jobTitles: action.payload,
        pageable: action.pageable
      }
    case LIST_JOB_TITLE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        jobTitles: []
      }
    case LIST_JOB_TITLE_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_JOB_TITLE_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        jobTitlesSummary: action.payload
      }
    case LIST_JOB_TITLE_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_JOB_TITLE_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_JOB_TITLE_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        jobTitles: [...state.jobTitles, action.payload]
      }
    case CREATE_JOB_TITLE_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_JOB_TITLE_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_JOB_TITLE_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        jobTitle: action.payload
      }
    case DETAIL_JOB_TITLE_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_JOB_TITLE_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_JOB_TITLE_SUCCESS:
      const updatedTitle = action.payload
      const updateFindIndexTitle = state.jobTitles.findIndex(jobTitle => jobTitle.id === updatedTitle.id)
      const updatedTitles = [...state.jobTitles]
      updatedTitles[updateFindIndexTitle] = updatedTitle

      return {
        ...state,
        loadingUpdate: false,
        jobTitles: updatedTitles
      }
    case UPDATE_JOB_TITLE_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_JOB_TITLE_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_JOB_TITLE_SUCCESS:
      const deletedTitleId = action.payload
      const deletedFindIndexTitle = state.jobTitles.findIndex(jobTitle => jobTitle.id === deletedTitleId)
      const deletedTitles = [...state.jobTitles]
      deletedTitles.splice(deletedFindIndexTitle, 1)

      return {
        ...state,
        loadingDelete: false,
        jobTitles: deletedTitles
      }
    case DELETE_JOB_TITLE_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default jobTitleReducer